import styled from 'styled-components';

import { Box } from '@/shared/ui/box';
import { Icon as UIIcon } from '@/shared/ui/icon';

export const Wrapper = styled(Box)`
	height: 100%;
	max-width: 100vw;
	background-color: ${({ theme: { modal } }) => modal.background};

	@media ${({ theme: { media } }) => media.mobile} {
		width: 100%;
		position: fixed;
		right: 0;
		top: 0;
		left: 0;
		bottom: 0;
		z-index: ${({ theme: { zIndex } }) => zIndex.modal};
	}
`;

export const Header = styled(Box)`
	border-bottom: 1px solid ${({ theme: { modal } }) => modal.border};
`;

export const Body = styled(Box)`
	flex: 1;
	overflow: auto;
`;

export const Footer = styled(Box)`
	border-top: 1px solid ${({ theme: { modal } }) => modal.border};
	background-color: ${({ theme: { modal } }) => modal.backgroundActions};
`;

export const CloseIcon = styled(UIIcon)`
	cursor: pointer;
	fill: ${({ theme: { modal } }) => modal.icon};
	transition: ${({ theme: { transition } }) => transition.primary};

	&:hover {
		opacity: 0.7;
	}
`;
